import script from "./BaseOverlay.vue?vue&type=script&setup=true&lang=ts"
export * from "./BaseOverlay.vue?vue&type=script&setup=true&lang=ts"

import "./BaseOverlay.vue?vue&type=style&index=0&id=b5389304&lang=sass&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b5389304"]])

export default __exports__